<template>
    <div>
        <h2>Scratch projekter</h2>
        <p>
            Her er nogle forskellige små Scratch-projekter, <br>
            der med forholdsvis simple koder viser hvordan man hopper, skyder, skifter baggrund osv.  <br>
            De fleste styres med piletasterne og mellemrumstasten. <br>
            Måske er der noget du kan bruge til netop dit spil.  <br>
            Hvis du trykker på ‘see inside’ kan du se hvordan det er kodet. <br>
            <br>
            Hvis du ikke kan finde det du skal bruge til dit spil her, så søg hjælp på Scratch.  <br>

        </p>
        <div class="embeds-small">
          <EmbedScratch id="380221807" title="Labyrint" />
          <EmbedScratch id="249968221" title="Skift baggrund" />
          <EmbedScratch id="249707072" title="Skydespil" />
          <EmbedScratch id="261681074" title="Hop på platform" />
          <EmbedScratch id="301209757" title="Saml ting op" />
          <EmbedScratch id="368930792" title="Simpel timer" />
        </div>

    </div>
</template>

<script>
import EmbedScratch from '@/components/ScratchEmbed';
export default {
  name: 'Links',
  components: {
    EmbedScratch
  }
}
</script>

<style>
  .embeds {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .embeds-small {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .embeds-small .scratchEmbed {
    /* // old
    height: 360px;
    width: 480px;
  */
    height: 340px;
    width: 470px;
  }
</style>


// WEBPACK FOOTER //
// src/components/pages/tips-og-tricks/scratch-projekter.vue